import { configLsKeyword } from '@/api/apiConstants'
import Config from '../config'

export const getLocalConfig = () => {
    const stringifiedConfig = localStorage.getItem(configLsKeyword)
    if (stringifiedConfig) {
        return JSON.parse(stringifiedConfig)
    }
    return null
}
export const saveLocalConfig = (remoteConfig: Config | null) => {
    if (remoteConfig) {
        const stringifiedConfig = JSON.stringify(remoteConfig)
        localStorage.setItem(configLsKeyword, stringifiedConfig)
    }
}
export const clearConfig = () => {
    localStorage.removeItem(configLsKeyword)
}
